/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Predictions API
 * API documentation for Predictions
 * OpenAPI spec version: 1.23.1
 */

export type WithdrawalControllerListStatus =
  (typeof WithdrawalControllerListStatus)[keyof typeof WithdrawalControllerListStatus];

export const WithdrawalControllerListStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
} as const;
